/**
 * ServiziCatalog — F-009.6 (lato agente). Elenco servizi extra acquistabili dal
 * wallet: nome, descrizione, prezzo + bottone "Acquista". Presentazionale.
 */
import type { ServizioResponse } from '@app/shared';
import { Button } from '@/components/ui/button';
import { centsToEuro } from '../lib/format';

interface ServiziCatalogProps {
  items: ServizioResponse[];
  onAcquista: (servizioId: string) => void;
  /** id del servizio in acquisto (per disabilitare/etichettare il bottone). */
  pendingId?: string | null;
}

export function ServiziCatalog({ items, onAcquista, pendingId }: ServiziCatalogProps) {
  return (
    <ul className="divide-y" aria-label="Servizi acquistabili">
      {items.map((s) => (
        <li
          key={s.id}
          className="flex flex-wrap items-center justify-between gap-3 py-3"
          data-servizio-id={s.id}
        >
          <div className="min-w-0">
            <p className="font-medium">{s.nome}</p>
            {s.descrizione ? (
              <p className="text-sm text-muted-foreground">{s.descrizione}</p>
            ) : null}
          </div>
          <div className="flex items-center gap-3">
            <span className="font-semibold tabular-nums">{centsToEuro(s.prezzoCents)}</span>
            <Button
              size="sm"
              onClick={() => onAcquista(s.id)}
              disabled={pendingId === s.id}
            >
              {pendingId === s.id ? 'Acquisto…' : 'Acquista'}
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
}
